// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2CxBD","rootNoMargin":"styles_rootNoMargin__3eBSF"};